export const concerns = [
  { heading: "치과 선택 고민", copy: "치과 선택할 때, 과잉 진료면 어쩌지", pose: 0 },
  { heading: "치과 선택 고민", copy: "치료를 앞두고, 많이 아프진 않을까", pose: 1 },
  { heading: "치과 선택 고민", copy: "평일엔 일해야 되는데, 진료시간 맞출 수 있을까", pose: 2 }
];

export const cases = [
  { category: "임플란트", title: "한쪽으로만 씹던 습관을 줄이도록", copy: "오른쪽 아래 어금니가 비어 반대편으로만 식사하던 경우입니다. CT로 잇몸뼈와 신경 위치를 확인하고, 주변 치아와 맞물리는 높이까지 조정했습니다.", image: "./assets/images/case-main-implant-single-v2.png" },
  { category: "치아 미백", title: "커피 착색이 신경 쓰이던 앞니", copy: "치아마다 달랐던 색과 기존 보철물의 밝기를 먼저 비교했습니다. 한 번에 과하게 밝히지 않고 얼굴에 어울리는 단계까지 나눠 진행했습니다.", image: "./assets/images/case-main-whitening-coffee-v2.png" },
  { category: "일반 진료", title: "씹을 때만 찌릿했던 어금니", copy: "겉으로 보이는 충치뿐 아니라 금이 간 범위와 신경 반응을 함께 검사했습니다. 자연치아를 남길 수 있는 범위를 확인한 뒤 필요한 부위부터 치료했습니다.", image: "./assets/images/case-main-molar-crack-v2.png" },
  { category: "임플란트", title: "식사할 때 움직이던 틀니", copy: "남아 있는 치아와 잇몸뼈 상태를 확인해 고정이 필요한 위치를 정했습니다. 씹을 때 흔들림을 줄이고 세척과 관리가 가능하도록 보철 형태를 맞췄습니다.", image: "./assets/images/case-main-implant-denture-v2.png" },
  { category: "치아 미백", title: "사진에서 유독 어두워 보이던 치아", copy: "앞니 표면의 착색과 치아 안쪽 색을 구분해 확인했습니다. 현재 치아에서 가능한 밝기를 먼저 보여드리고 단계별로 변화를 확인했습니다.", image: "./assets/images/case-main-whitening-photo-v2.png" }
];

export const implantCases = [
  {
    category: "단일 임플란트",
    title: "한쪽으로만 씹던 빈 어금니 자리",
    copy: "CT로 잇몸뼈의 상태를 확인하고, 반대편 치아와 맞물리는 높이까지 고려해 식립 위치를 계획합니다.",
    image: "./assets/images/case-implant-single-molar-v2.png",
  },
  {
    category: "앞니 임플란트",
    title: "웃을 때 먼저 보이는 앞니 자리",
    copy: "잇몸선과 양옆 치아의 모양, 얼굴에서 보이는 치아의 비율을 함께 살펴 자연스럽게 이어지도록 보철을 계획합니다.",
    image: "./assets/images/case-implant-anterior-v2.png",
  },
  {
    category: "다수 임플란트",
    title: "여러 어금니가 함께 비어 있다면",
    copy: "씹는 힘이 한쪽에 몰리지 않도록 식립 위치와 보철 연결 범위를 정하고, 위아래 치아의 맞물림을 함께 조정합니다.",
    image: "./assets/images/case-implant-multiple-posterior-v2.png",
  },
  {
    category: "임플란트 틀니",
    title: "식사할 때마다 움직이던 틀니",
    copy: "남아 있는 치아와 잇몸뼈 상태를 확인해 필요한 고정 위치를 정하고, 씹을 때 흔들림과 들뜸을 줄이도록 연결 구조를 설계합니다.",
    image: "./assets/images/case-implant-overdenture-v2.png",
  },
  {
    category: "전체 임플란트",
    title: "여러 치아가 비어 식사가 어려웠다면",
    copy: "전체 치열의 높이와 입술선, 위아래 치아의 맞물림을 함께 확인해 기능과 인상을 모두 고려한 보철 계획을 세웁니다.",
    image: "./assets/images/case-implant-full-arch-v2.png",
  },
];

export const implantFaqs = [
  {
    question: "임플란트 아프지 않나요?",
    answer: "수술 후에는 개인차에 따라 통증과 부기가 생길 수 있습니다. 365서울감동치과는 표면 마취, 무바늘 마취, 극미세침 마취 등 단계별 마취와 치료 중 상태 확인으로 과정의 부담을 줄이기 위해 노력합니다.",
  },
  {
    question: "임플란트의 수명은 어떻게 되나요?",
    answer: "임플란트의 사용 기간은 구강 위생, 잇몸 상태, 교합과 생활 습관에 따라 달라집니다. 자연치아처럼 꼼꼼하게 관리하고 정기검진을 이어가면 오랫동안 안정적으로 사용하는 데 도움이 됩니다.",
  },
  {
    question: "임플란트 치료 기간은 어느 정도인가요?",
    answer: "잇몸뼈 상태와 골 이식 여부에 따라 달라지지만, 일반적으로 아랫니는 2~3개월, 윗니는 5~6개월 정도의 기간을 예상합니다. 검사 결과와 회복 속도에 따라 전체 일정은 달라질 수 있습니다.",
  },
  {
    question: "임플란트를 못할 수도 있나요?",
    answer: "전신질환이 있다고 임플란트가 모두 불가능한 것은 아닙니다. 현재 질환의 조절 상태와 복용 약을 먼저 확인하고, 필요한 경우 주치의와 협진한 뒤 CT와 구강 검사 결과를 바탕으로 가능 여부와 치료 시기를 결정합니다.",
  },
];

export const doctors = [
  { name: "이정웅", role: "대표원장 · 통합치의학과 전문의", image: "./assets/images/doctor-lee-jungwoong.png", quote: "환자분이 이해하고 선택할 수 있도록 치료의 이유부터 설명하겠습니다.", careers: ["경희대학교 치과대학 치의학석사", "서울대학교 치과병원 마취통증의학과 EXTERNSHIP 수료", "미국 유펜 치과대학 근관치료과정 수료"] },
  { name: "이명훈", role: "원장 · 통합치의학과 전문의", image: "./assets/images/doctor-lee-myung-hoon.png", quote: "치료 경험을 바탕으로 현재 상태에 필요한 방법부터 차분히 찾겠습니다.", careers: ["전남대학교 치의학전문대학원 치의학석사", "Dentalbean Standard Implant Course 수료", "Sinus Bone Augmentation Course 수료"] },
  { name: "김윤희", role: "원장 · 통합치의학과 전문의", image: "./assets/images/doctor-kim-yoonhee.png", quote: "자연치아를 오래 지킬 수 있는 가능성을 먼저 살피겠습니다.", careers: ["전북대학교 치의학전문대학원 치의학석사 D.D.S.", "서울대학교 치의학대학원 치주임플란트학 수료", "오스템 AIC 임플란트 마스터코스 수료"] },
  { name: "여상원", role: "수석원장 · 안면통증구강내과 전문의", image: "./assets/images/doctor-yeo-sangwon.png", quote: "치아뿐 아니라 턱과 얼굴의 통증까지 원인을 함께 살펴보겠습니다.", careers: ["보건복지부 인증 통합치의학과 전문의", "연세대학교 치과대학 박사", "대한안면통증구강내과학회 정회원"] }
];

export const reviews = [
  { nickname: "하늘***", counts: "리뷰 18 · 사진 4 · 팔로워 2", avatar: "./assets/images/review-profile-01.jpg", message: "CT 사진을 같이 보면서 뼈가 부족한 곳과 수술 순서를 설명해 주셨어요. 당장 해야 하는 치료와 기다려도 되는 치료를 나눠 알려줘서 결정하기 편했습니다." },
  { nickname: "마음***", counts: "리뷰 9 · 사진 2 · 팔로워 1", avatar: "./assets/images/review-profile-02.jpg", message: "퇴근하고 방문했는데 진료가 급하게 돌아가는 느낌이 없었어요. 아픈 치아부터 확인하고 오늘 할 수 있는 치료와 다음 일정까지 한 번에 안내받았습니다." },
  { nickname: "도담***", counts: "리뷰 27 · 사진 8 · 팔로워 5", avatar: "./assets/images/review-profile-03.jpg", message: "마취 주사 때문에 긴장했는데 표면 마취부터 천천히 진행해 주셨어요. 치료 중간에도 괜찮은지 계속 확인해 주셔서 생각보다 편하게 끝냈습니다." },
  { nickname: "해봄***", counts: "리뷰 14 · 사진 6 · 팔로워 3", avatar: "./assets/images/review-profile-04.jpg", message: "치료가 끝난 뒤 칫솔이 잘 닿지 않는 위치를 거울로 직접 보여주셨어요. 다음 검진 때 확인할 부분까지 적어 주셔서 집에서 관리하기 쉬웠습니다." },
  { nickname: "윤슬***", counts: "리뷰 31 · 사진 12 · 팔로워 7", avatar: "./assets/images/review-profile-05.jpg", message: "아이가 기계 소리를 무서워했는데 기구를 먼저 보여주고 손에 올려보게 해주셨어요. 울지 않고 진료를 마쳐서 다음 방문도 걱정이 덜합니다." },
  { nickname: "새벽***", counts: "리뷰 22 · 사진 5 · 팔로워 4", avatar: "./assets/images/review-profile-06.png", message: "엑스레이를 같이 보면서 왜 통증이 생겼는지부터 설명해 주셨어요. 치료 횟수와 비용을 시작 전에 들을 수 있어 일정을 잡기 편했습니다." }
];
